export default (variableName) =>
  getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim()
